import type { FaireProductEntity } from "../../entity_types/product";

export const p_hcctenmcq9: FaireProductEntity = {
  token: "p_hcctenmcq9",
  type: "product",
  name: "Serangoon Market Tandoori BBQ Sauce",
  brandToken: "b_memu3px42g",
  brandName: "Serangoon Market",
  imageUrl:
    "https://cdn.faire.com/fastly/5cdcc9036e9f9e0909e3f75701ad9ef36e78d6823c5de4051ef84bb4d3e1e651.png",
  galleryImageUrls: [],
  priceDollars: 6.99,
  description:
    "\nGet ready to fire up your grill with Serangoon Market's Tandoori BBQ Sauce! This isn't your typical barbecue sauce—it's a flavor-packed adventure that brings the unique and smoky taste of tandoori straight to your plate. It’s thick and viscous, with a texture that generously coats your food, ensuring every bite is a bold and unforgettable experience. The flavor is a perfect balance of smoky, sweet, and tangy notes, making it a truly unusual and delicious addition to your kitchen.\n\nThis sauce is a superstar with ribs and beef, but its versatility knows no bounds! Slather it on your favorite grilled meats, or use it to bring a smoky, funky twist to everyday meals. You can even use it as a zesty topping on sandwiches to add an amazing tandoori kick, or mix it into marinara sauce to create a unique and unforgettable pizza or pasta dish. Let the culinary creativity begin!",
  tags: [],
  msrpDollars: 10.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:16.310Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
